/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

export const useLogout = () => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.LOGOUT],
    mutationFn: async () => {
      const response = await axios.api.post('ajax/logout', {
        format: 'json',
      })
      return response.data
    },
  })
}
